<template>
  <footer class="footer-pages">
    <div class="min-footer">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-xl-5 col-lg-6 col-md-7 col-sm-12 col-12 border-top-min">
            <div class="row">
              <div class="col-xl-5 col-lg-5 col-md-6 col-sm-6 col-12 alinmov2  pt-1">
                <img
                  src="https://upcdn.io/FW25b8h/raw/logos/rhomtrip/rhomtrip-v1p300.png"
                  class="logo"
                  alt="Logo Rhomtrip"
                />
              </div>
              <div class="col-xl-7 col-lg-7 col-md-6 col-sm-6 col-12  alinmov2 align-self-center pt-1">
                <div class="content">
                  <div class="content-footer">
                    <div class="col-lg-12 align-self-center conter-footer p-0">
                      <ul class="social-media mt-sm-1 mt-2">
                        <li>
                          <a
                            href="https://www.linkedin.com/company/rhomtrip"
                            target="blank"
                          >
                            <i class="flaticon-bold flaticon-bold-linkedin"></i>
                          </a>
                        </li>

                        <li>
                          <a
                            href="https://www.instagram.com/rhomtrip/"
                            target="blank"
                          >
                            <i
                              class="flaticon-bold flaticon-bold-instagram"
                            ></i>
                          </a>
                        </li>
                        <li>
                          <a
                            href="https://www.facebook.com/rhomtrip"
                            target="blank"
                          >
                            <i
                              class="flaticon-bold flaticon-bold-facebook-app-symbol"
                            ></i>
                          </a>
                        </li>
                        <li>
                          <a
                            href="https://www.x.com/rhomtrip"
                            target="_blank"
                            aria-label="twitter RhomTrip"
                          >
                            <i class="flaticon-web-twitter-1"></i>
                          </a>
                        </li>

                        <li>
                          <a href="mailto:info@rhomtrip.com" target="_blank">
                            <i class="flaticon-envelope"></i>
                          </a>
                        </li>

                        <li>
                          <a href="https://rhomtrip.com/contact" target="blank">
                            <i class="flaticon-bold-telephone"></i>
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="bottom-footer-suppliers border-top-min">
              <div class="row justify-content-center">
                <div class="col-xl-12">
                  <div class="row">
                    <div
                      class="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-3 align-self-center"
                    >
                      <a href="https://www.iata.org" target="_blank">
                        <img
                          class="img-fluid"
                          src="https://upcdn.io/FW25b8h/raw/signature/rhomtrip/rhomtrip-iata-code.png"
                          alt="iata-code"
                      /></a>
                    </div>
                    <div
                      class="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-3 align-self-center"
                    >
                      <a href="https://www.asta.org/" target="_blank">
                        <img
                          class="img-fluid"
                          src="https://upcdn.io/FW25b8h/raw/signature/rhomtrip/asta-travel-advisors.png"
                          alt="asta"
                      /></a>
                    </div>
                    <div
                      class="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-3 align-self-center"
                    >
                      <a href="https://www.octo.travel" target="_blank">
                        <img
                          class="img-fluid"
                          src="https://upcdn.io/FW25b8h/raw/signature/rhomtrip/octo-travel.png"
                          alt="octo"
                      /></a>
                    </div>
                    <div
                      class="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-3 align-self-center"
                    >
                      <a href="https://www.tripadvisor.com" target="_blank">
                        <img
                          class="img-fluid filter-tripadvisor"
                          src="https://upcdn.io/FW25b8h/raw/signature/rhomtrip/tripadvisor-2023-2024.png"
                          alt="tripadvisor"
                      /></a>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="text-center border-top-min">
              <p class="copyright-neg pt-1">
                Copyright © {{ systemInfo.year }}. RhomTrip OÜ™. Register Nº:
                14554819.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>
<script>
import { mapGetters, mapMutations } from "vuex";

export default {
  name: "layoutFooter",
  data() {
    return {};
  },
  methods: {
    ...mapMutations(["setSystemInfo"])
  },
  computed: {
    ...mapGetters(["systemInfo"])
  }
};
</script>
<style></style>
